import { render, staticRenderFns } from "./StepTeleconsultationDirect.vue?vue&type=template&id=55abe3e1&scoped=true&"
import script from "./StepTeleconsultationDirect.vue?vue&type=script&lang=js&"
export * from "./StepTeleconsultationDirect.vue?vue&type=script&lang=js&"
import style0 from "./StepTeleconsultationDirect.vue?vue&type=style&index=0&id=55abe3e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55abe3e1",
  null
  
)

export default component.exports